import { GenericService } from './generic.service';
import { Anatomy } from '@/models';

export class AnatomyService extends GenericService<Anatomy> {
  endpoint = 'v1/anatomies';
}
